// import SliderArrow from "~/assets/images/icons/slider-arrow.svg?inline";

export default {
  name: "street-photo",

  data() {
    return {
      photo: "",
      // isPhotoAvailable: true,
      gkey: process.env.VUE_APP_GOOGLE_MAPS_KEY
    };
  },

  props: {
    street: {
      type: String,
      default: ""
    },

    isOnMarket: {
      type: Boolean,
      default: true
    },

    propertyId: {
      type: String
    },

    fullAddress: {
      type: String
    }
  },

  mounted: function() {
    if (this.isOnMarket) {
      this.photo = require("@/assets/images/pictures/bushes@2x.jpg");
    } else {
      this.photo = `https://maps.googleapis.com/maps/api/streetview?size=360x200&location=${this.street}&key=${this.gkey}`;
    }
  },

  methods: {},

  components: {}
};
